import React from 'react';
export const StatsBar = () => {
  return <div className="border-y border-legal-700 bg-legal-800/50 py-8" data-id="element-187" data-mp="jxnff15hepjl">
      <div className="container mx-auto px-4" data-id="element-188" data-mp="1tbjift0ew4fe">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x-0 md:divide-x divide-legal-700" data-id="element-189" data-mp="1t8niy08x17ou">
          <div className="flex flex-col items-center justify-center" data-id="element-190" data-mp="1jckhkwlw1d2y">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-191" data-mp="1jeet5kb9rsud">⭐ 4.9</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-192" data-mp="1eesed6fsm4jg">
              500+ ventas
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-193" data-mp="15knrsz7ozf9q">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-194" data-mp="15it97rjw7z8t">100</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-195" data-mp="10ndukxe29zbc">
              Modelos editables
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-196" data-mp="qn4uv9kv1vr7">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-197" data-mp="qpzfb13vjgkm">2026</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-198" data-mp="3omstwbhwaiq9">
              Jurisprudencia actual
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-199" data-mp="3eqph8bpf31p2">
            <span className="text-3xl font-bold text-white mb-1" data-id="element-200" data-mp="3jp0ruonjdg8c">7 días</span>
            <span className="text-xs text-gold-500 font-semibold tracking-wider uppercase" data-id="element-201" data-mp="3jmwqoeh0uvbr">
              Garantía total
            </span>
          </div>
        </div>
      </div>
    </div>;
};